module.exports = __webpack_public_path__ + "img/tar.e67e0f17.jpg";